module.exports = "<div class=\"footer\">\n  <a [routerLink]=\"'/'\">\n    <img src=\"/assets/img/FOOTER_03.png\" class=\"d-none d-md-block d-lg-block d-xl-block\">\n    <img src=\"/assets/img/FOOTER_Mobile.png\" class=\"d-block d-md-none d-lg-none d-xl-none\">\n  </a>\n\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main